import { Button } from "@/components/ui/button"
import { ZoomIn, ZoomOut } from "lucide-react"
import L from 'leaflet'

interface ZoomControlsProps {
  map: L.Map | null
}

/**
 * Component for zoom in/out controls
 */
export function ZoomControls({ map }: ZoomControlsProps) {
  if (!map) return null

  return (
    <div className="bg-background/90 backdrop-blur-sm rounded-lg p-2 space-y-1 shadow-lg" style={{ display: 'flex', width: 100, justifyContent: 'space-around' }}>
      <Button size="sm" variant="outline" onClick={() => map.zoomIn()}>
        <ZoomIn className="h-4 w-4" />
      </Button>
      <Button size="sm" variant="outline" onClick={() => map.zoomOut()}>
        <ZoomOut className="h-4 w-4" />
      </Button>
    </div>
  )
}
